export default __webpack_public_path__ + "static/media/photo--lg--47.ce01ceaa.jpg";